module.exports = __webpack_public_path__ + "static/media/cartoes_elo.c3ae9a5d.svg";